import { Feuerwehr } from "@/backend_controller/feuerwehr";
import { Hydranten } from "@/backend_controller/hydranten";
import { Wasserquellenarten } from "@/backend_controller/wasserquellenarten";
import Swal from "sweetalert2";

export class HydrantenController {
    konvKey;
    mapRef;
    bounds;
    feuerwehrID;
    partnerFeuerwehren;
    alleHydranten = [];
    aktiveHydranten = [];

    constructor(konvKey, mapRef, feuerwehrID, partnerFeuerwehren){
        this.konvKey = konvKey;
        this.mapRef = mapRef;
        this.feuerwehrID = feuerwehrID;
        this.partnerFeuerwehren = partnerFeuerwehren;
    }

    async init(aenderungszeitpunkt){
        await this.loadHydranten(aenderungszeitpunkt);
    }

    getHydrantenInBounds(bounds){
        let padding = 0.01; // ca. 1000m Puffer
        const nord = bounds._northEast.lng + padding;
        const ost = bounds._northEast.lat + padding;
        const sued = bounds._southWest.lng - padding;
        const west = bounds._southWest.lat - padding;
        console.log("Bounds mit Puffer:", { nord, ost, sued, west });
        console.log("Alle Hydranten:", this.alleHydranten);
        this.aktiveHydranten = this.alleHydranten.filter(hydrant => {
            return hydrant.position.y >= sued && hydrant.position.y <= nord && hydrant.position.x >= west && hydrant.position.x <= ost;
        });
    }

    async loadHydranten(aenderungszeitpunkt){
        let response = await Hydranten.get(this.konvKey);
        if(response){
            this.alleHydranten = response;
            localStorage.setItem("hydranten", JSON.stringify(this.alleHydranten));
            localStorage.setItem("aenderungszeitpunktHydrant", aenderungszeitpunkt);
        } else {
            this.alleHydranten = JSON.parse(localStorage.getItem("hydranten"));
            console.log("Hydranten aus localStorage geladen:", this.alleHydranten);
        }
    }

    async addHydrant(x, y){
        let wasserquellenarten = await this.getWasserquellenarten();
        if(wasserquellenarten.length == 0){
            return;
        }

        let html = `<select id="wasserquellenarten" class="swal2-select">`;
        wasserquellenarten.forEach(wasserquellenart => {
            html += `<option value="${wasserquellenart.wasserquellenartID}">${wasserquellenart.name}</option>`;
        });
        html += `</select>
                <input id="durchlaufmenge" maxLength="3" type="number" class="swal2-input" placeholder="Durchlaufmenge" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important">
                <input id="bemerkung" maxLength="80" class="swal2-input" placeholder="Bemerkung" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important"><br>`;

        const { value: formValues } = await Swal.fire({
            title: 'Neuen Hydranten hinzufügen',
            html: html,
            focusConfirm: false,
            preConfirm: () => {
                const selectedWasserquellenartId = document.getElementById('wasserquellenarten').value;
                const durchlaufmenge = document.getElementById('durchlaufmenge').value;
                const bemerkung = document.getElementById('bemerkung').value;
                return { selectedWasserquellenartId, durchlaufmenge, bemerkung };
            }
        });
        if(formValues){
            console.log("Formularwerte:", formValues);
            let response = await Hydranten.add(x, y, formValues.durchlaufmenge, formValues.bemerkung, formValues.selectedWasserquellenartId, this.feuerwehrID);
            if(response){
                let neuerHydrant = {
                    hydrantenID: response.insertId,
                    position: { x: x, y: y },
                    durchlaufmenge: formValues.durchlaufmenge,
                    bemerkung: formValues.bemerkung,
                    wasserquellenartID: formValues.selectedWasserquellenartId,
                    feuerwehrID: this.feuerwehrID
                };
                this.alleHydranten.push(neuerHydrant);
                this.aktiveHydranten.push(neuerHydrant);
                localStorage.setItem("hydranten", JSON.stringify(this.alleHydranten));
                let response2 = await Feuerwehr.updateAenderungszeiger(this.feuerwehrID);
                console.log("Aenderungszeiger aktualisiert:", response2);
                Swal.fire({
                    icon: 'success',
                    title: 'Erfolg',
                    text: 'Der Hydrant wurde erfolgreich hinzugefügt.',
                });
            }
        }
    }

    async getWasserquellenarten(){
        let response = await Wasserquellenarten.get();
        if(response){
            return response;
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Fehler',
                text: 'Die Wasserquellenarten konnten nicht geladen werden. Bitte versuche es später erneut.',
            });
            return [];
        }
    }

    async deleteHydrant(hydrantID){
        await Swal.fire({
            title: 'Bist du sicher?',
            text: "Möchtest du diesen Hydranten wirklich löschen?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja, löschen!',
            cancelButtonText: 'Abbrechen'
        }).then(async (result) => {
            if (result.isConfirmed) {
                let response = await Hydranten.delete(hydrantID, this.feuerwehrID);
                if(response){
                    this.alleHydranten = this.alleHydranten.filter(hydrant => hydrant.wasserquellenID !== hydrantID);
                    this.aktiveHydranten = this.aktiveHydranten.filter(hydrant => hydrant.wasserquellenID !== hydrantID);
                    localStorage.setItem("hydranten", JSON.stringify(this.alleHydranten));
                    let response2 = await Feuerwehr.updateAenderungszeiger(this.feuerwehrID);
                    console.log("Aenderungszeiger aktualisiert:", response2);
                    Swal.fire({
                        icon: 'success',
                        title: 'Gelöscht',
                        text: 'Der Hydrant wurde erfolgreich gelöscht.',
                    });
                }
            }
        });
    }

    async editHydrant(hydrantObj){
        if(hydrantObj.feuerwehrID !== this.feuerwehrID){
            Swal.fire('Funktion nicht möglich', 'Sie können nur eigene Hydranten bearbeiten', 'error');
            return;
        }
        let wasserquellenarten = await this.getWasserquellenarten();
        if(wasserquellenarten.length == 0){
            return;
        }

        let html = `<select id="wasserquellenarten" class="swal2-select">`;
        wasserquellenarten.forEach(wasserquellenart => {
            if(hydrantObj.wasserquellenartID === wasserquellenart.wasserquellenartID){
                html += `<option value="${wasserquellenart.wasserquellenartID}" selected>${wasserquellenart.name}</option>`;
            } else {
                html += `<option value="${wasserquellenart.wasserquellenartID}">${wasserquellenart.name}</option>`;
            }
        });
        html += `</select>
                <input id="durchlaufmenge" value="${hydrantObj.durchlaufmenge}" maxLength="3" type="number" class="swal2-input" placeholder="Durchlaufmenge" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important">
                <input id="bemerkung" value="${hydrantObj.bemerkung}" maxLength="80" class="swal2-input" placeholder="Bemerkung" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important"><br>`;

        const { value: formValues } = await Swal.fire({
            title: 'Hydrant bearbeiten',
            html: html,
            focusConfirm: false,
            preConfirm: () => {
                const selectedWasserquellenartId = document.getElementById('wasserquellenarten').value;
                const durchlaufmenge = document.getElementById('durchlaufmenge').value;
                const bemerkung = document.getElementById('bemerkung').value;
                return { selectedWasserquellenartId, durchlaufmenge, bemerkung };
            }
        });
        if(formValues){
            console.log("Formularwerte:", formValues);
            let response = await Hydranten.update(hydrantObj.wasserquellenID, hydrantObj.position.x, hydrantObj.position.y, formValues.durchlaufmenge, formValues.bemerkung, formValues.selectedWasserquellenartId, this.feuerwehrID);
            if(response){
                let bearbeiteterHydrant = {
                    wasserquellenID: response.wasserquellenID,
                    position: { x: hydrantObj.position.x, y: hydrantObj.position.y },
                    durchlaufmenge: formValues.durchlaufmenge,
                    bemerkung: formValues.bemerkung,
                    wasserquellenartID: formValues.selectedWasserquellenartId,
                    feuerwehrID: this.feuerwehrID
                };
                this.alleHydranten = this.alleHydranten.map(hydrant => {
                    if(hydrant.wasserquellenID === bearbeiteterHydrant.wasserquellenID){
                        return bearbeiteterHydrant;
                    }
                    return hydrant;
                });
                this.aktiveHydranten = this.aktiveHydranten.map(hydrant => {
                    if(hydrant.wasserquellenID === bearbeiteterHydrant.wasserquellenID){
                        return bearbeiteterHydrant;
                    }
                    return hydrant;
                });
                localStorage.setItem("hydranten", JSON.stringify(this.alleHydranten));
                let response2 = await Feuerwehr.updateAenderungszeiger(this.feuerwehrID);
                console.log("Aenderungszeiger aktualisiert:", response2);
                Swal.fire({
                    icon: 'success',
                    title: 'Erfolg',
                    text: 'Der Hydrant wurde erfolgreich bearbeitet.',
                });
            }
        }
    }
}